import { TActualApplicationResponse_1 } from 'shared/common/repositories/mortgage/v1/actual-application';

import { IAbortableRequest, withRequestTimeout } from './withRequestTimeout';

/** Любая неудача трактуется как «заявки нет»: оставить клик по CTA без результата хуже,
    чем показать лишний онбординг. */
export async function hasUnfinishedAnketa(request: IAbortableRequest<TActualApplicationResponse_1>): Promise<boolean> {
  try {
    const actualApplication = await withRequestTimeout(request);

    /* TODO: CD-277911 — отправленной заявке нужна своя модалка со статусом, а не модалка черновика.
       Отдельной проверки времени там не понадобится: статус `submitted` бек отдаёт только при
       неистёкшем слоте звонка, см. LeadApplication.is_actual в сервисе mortgage */
    return Boolean(actualApplication.status);
  } catch {
    return false;
  }
}
